<template>
  <footer class="footer">
        <div class="col-sm-4 col-md-7">
          <p class="copyright">
            © Copyright Rastreator.com {{ year }}.<br />
            Todos los Derechos Reservados
          </p>
        </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss">
@import "../../core/core-framework/assets/scss/inc/mixins/_text_mixins.scss";
@import "../../core/core-framework/assets/scss/inc/_variables.scss";
@import "../../core/core-framework/assets/scss/inc/_bootstrap_custom_variables.scss";

footer.footer {
  background-color: $color-blue-02;
  padding: 16px 0;
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  bottom: 0;
  @media screen and (min-width: $screen-md) {
    padding: 48px 0;
    .row {
      display: flex;
      > div:first-child {
        order: 2;
      }
      > div:last-child {
        order: 1;
      }
    }
  }
  ul {
    display: flex;
    justify-content: space-between;
    padding: 0 0 8px;
    margin: 0 0 8px;
    width: 100%;
    list-style: none;
    border-bottom: 1px solid rgba($color: $color-grey-06, $alpha: 0.2);
    @media screen and (min-width: $screen-md) {
      border: none;
      margin: 0;
      padding: 0;
    }
    li {
      a {
        @include text(
          $size: 12px,
          $weight: 500,
          $color: $color-white,
          $lineheight: 20px
        );
        text-decoration: none;
        @media screen and (min-width: $screen-md) {
          @include text($size: 14px, $lineheight: 18px);
        }
        &:hover {
          color: $color-white;
          text-decoration: none;
        }
      }
    }
  }
  .copyright {
    @include text($size: 11px, $color: $color-grey-04, $lineheight: 20px);
    text-align: center;
    margin: 0;
    @media (min-width: $screen-sm) {
      @include text($size: 14px, $lineheight: 24px, $color: $color-grey-03);
    }
    @media (min-width: $screen-md) {
      text-align: left;
      padding-left: 60px;
    }
    br {
      display: none;
      @media screen and (min-width: $screen-sm) and (max-width: $screen-md) {
        display: block;
      }
    }
  }
}

</style>
